<template>
  <v-card v-if="showDebugMode"
          density="compact"
          :class="cardClasses"
          min-width="340"
  >
    <v-card-title>
      {{type}} <span v-if="itemId">&nbsp;({{itemId}})&nbsp;</span> {{conditionType}}

      <v-chip
          v-if="conditions?.[conditionType]?.mode"
          density="compact"
          class="mr-2 right-0 position-absolute"
      >
        {{conditions?.[conditionType]?.mode}}
      </v-chip>
    </v-card-title>
    <v-card-item
        v-if="conditions?.[conditionType]?.items?.length > 0"
        v-for="item in conditions?.[conditionType]?.items"
        class="pa-0">
      <v-icon :icon="item?.reverse ? mdiArrowULeftTop : mdiArrowRightThin"></v-icon>
      <span v-if="item?.questionLinkedId !== null">{{item?.questionLinkedId}} - </span>
      <span>{{item?.type}}</span>
      <span v-if="item?.value !== null"> - {{item?.value}}</span>
    </v-card-item>
  </v-card>
</template>

<script setup>
import { computed } from 'vue';
import { useApplicationStore } from '@/stores/applicationStore';
import { mdiArrowULeftTop, mdiArrowRightThin } from '@mdi/js';

const props = defineProps({
  conditions: {
    required: true
  },
  type: {
    type: String,
    required: false,
    default: 'Question'
  },
  conditionType: {
    type: String,
    required: false,
    default: 'visibility'
  },
  itemId: {
    type: [Number, String],
    required: false
  }
});

const applicationStore = useApplicationStore();

const cardClasses = computed(() => {
  let classes = new Set();
  classes.add('text-white', true);
  classes.add('mr-1', true);
  classes.add('mb-1', true);
  classes.add('d-inline-block', true);
  classes.add('opacity-70', true);
  let bgColor = 'bg-'
  switch (props.conditionType) {
    case 'visibility':
      bgColor += 'teal';
      break;
    case 'validity':
      bgColor += 'deep-orange';
      break;
    case 'mandatory':
      bgColor += 'deep-purple';
      break;
    default:
      bgColor += 'blue-grey';
  }
  switch (props.type) {
    case 'Screen':
      bgColor += '-darken-2';
      break;
    case 'Group':
      bgColor += '-darken-4';
      break;
  }
  classes.add(bgColor);
  return Object.assign(...Array.from(classes, v => ({[v]:true})));
});

const showDebugMode = computed(() => applicationStore.showDebugMode);
</script>